var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.8 125.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#80D4FF;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Insights") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.11,95.52a2,2,0,0,1-2-1.86c-.55-8.52-3.63-10.9-7.52-13.91-4.85-3.77-10.36-8-11.39-23.81a29.48,29.48,0,0,1,8.25-22.18A37.6,37.6,0,0,1,56.9,22.13,38.19,38.19,0,0,1,84.45,33.84,29.28,29.28,0,0,1,92.58,56c-1.08,15.32-6.41,19.56-11.1,23.3-2.79,2.23-5.21,4.15-6.69,8.39a2,2,0,1,1-3.74-1.3c1.85-5.33,5-7.8,8-10.19,4.45-3.55,8.65-6.9,9.62-20.48a25.32,25.32,0,0,0-7.09-19.12,34.24,34.24,0,0,0-49.17-.08,25.55,25.55,0,0,0-7.19,19.21c.91,14,5.46,17.52,9.86,20.93,4.12,3.19,8.38,6.49,9.05,16.79a2,2,0,0,1-1.85,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.63,119.8a2,2,0,0,1-.51-3.9l30.38-8a2,2,0,0,1,2.42,1.41,2,2,0,0,1-1.42,2.43l-30.37,8A1.77,1.77,0,0,1,42.63,119.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.63,108.35a2,2,0,0,1-.51-3.9l30.38-8a2,2,0,1,1,1,3.84l-30.37,8A1.77,1.77,0,0,1,42.63,108.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.63,96.9a2,2,0,0,1-.51-3.9L72.5,85a2,2,0,1,1,1,3.84l-30.37,8A1.77,1.77,0,0,1,42.63,96.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.91,125.53a13.33,13.33,0,0,1-10.62-5,2,2,0,0,1,3.16-2.41,9.32,9.32,0,0,0,7.46,3.45c4.89,0,8.86-3.35,8.86-7.45a2,2,0,1,1,4,0C69.74,120.41,64,125.53,56.91,125.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,14.17a2,2,0,0,1-2-2V2a2,2,0,0,1,4,0V12.19A2,2,0,0,1,58,14.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.77,25.3a2,2,0,0,1-1.4-3.39l7.22-7.22a2,2,0,1,1,2.8,2.81l-7.22,7.22A2,2,0,0,1,87.77,25.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.82,57.83h-10.2a2,2,0,1,1,0-4h10.2a2,2,0,0,1,0,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.52,95.93a2,2,0,0,1-1.4-.58L84.9,88.13a2,2,0,0,1,2.8-2.81l7.22,7.22a2,2,0,0,1-1.4,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.5,25.3a2,2,0,0,1-1.4-.59L18.89,17.5a2,2,0,1,1,2.8-2.81l7.22,7.22A2,2,0,0,1,27.5,25.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.19,55.75H2a2,2,0,0,1,0-4H12.19a2,2,0,0,1,0,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.81,95.93a2,2,0,0,1-1.4-.58,2,2,0,0,1,0-2.81l7.22-7.22a2,2,0,1,1,2.8,2.81l-7.21,7.22A2,2,0,0,1,18.81,95.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.81,78.4a2,2,0,0,1-1.61-.81L43.12,62.33A2,2,0,0,1,46.33,60L55.6,72.76,70.77,46a2,2,0,0,1,3.45,2L57.53,77.4a2,2,0,0,1-1.61,1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/Insights.e932cf36ef008cfc4129a54b5a44808f.svg";
export { ForwardRef as ReactComponent };